import { ViewHook } from "phoenix_live_view";

class InputClearButton extends ViewHook {
  private input?: HTMLInputElement;
  private clearEvent?: string;

  mounted() {
    this.onInputChanged = this.onInputChanged.bind(this);
    this.onClearButtonClicked = this.onClearButtonClicked.bind(this);

    const { inputId, clearEvent } = this.el.dataset;

    if (!inputId) {
      console.error("InputClearButton: missing required data-attributes");
      return;
    }

    this.input = document.querySelector(`#${inputId}`) as HTMLInputElement;
    this.clearEvent = clearEvent;

    if (!this.input) {
      console.error("InputClearButton: input not found");
      return;
    }

    if (this.input.value && this.input.value.length > 0) {
      this.el?.removeAttribute("hidden");
    } else {
      this.el?.setAttribute("hidden", "");
    }

    this.input.addEventListener("input", this.onInputChanged);
    this.el.addEventListener("click", this.onClearButtonClicked);
  }

  destroyed() {
    this.input?.removeEventListener("input", this.onInputChanged);
    this.el?.removeEventListener("click", this.onClearButtonClicked);

    this.input = undefined;
    this.clearEvent = undefined;
  }

  private onInputChanged() {
    if (this.input?.value && this.input?.value.length > 0) {
      this.el?.removeAttribute("hidden");
    } else {
      this.el?.setAttribute("hidden", "");
    }
  }

  private onClearButtonClicked() {
    if (this.input) {
      this.input.value = "";
    }

    this.el?.setAttribute("hidden", "");
    this.input?.focus();
    this.input?.dispatchEvent(new Event("cleared"));

    if (this.clearEvent) {
      void this.pushEvent(this.clearEvent, {});
    }
  }
}

export default InputClearButton;
